import Typography from "../Typography/Typography"
import { Link } from "react-router-dom"
import styles from "./style.module.css"

interface itemProp {
    id?: string
    deliveryDate?: string
    name?: string
    image?: string
    route?: string
    product?: boolean
    items?: string | number
    storeVisits?: string | number
}

export const RateProductItem: React.FC<itemProp> = ({
    id,
    deliveryDate,
    name,
    image,
    route,
    product = false,
    items,
    storeVisits,
}) => {
    return (
        <div className={styles.container}>

            <div className={styles.wrap}>
                <div className={styles.image}>
                    <img className={styles.img} src={image} alt="" />
                </div>
                <div className={styles.detailedContainer}>
                    <Typography
                        variant="heading5"
                    >
                        {name}
                    </Typography>

                    {product ? (
                        <Typography>
                            Item Purchased: {items}
                        </Typography>
                    ) : (
                        <Typography>
                            Order Id: #{id}
                        </Typography>
                    )
                    }

                    {product ? (
                        <Typography
                            variant="heading6"
                        >
                            Store visit: {storeVisits}
                        </Typography>
                    ) : (
                        <Typography
                            variant="heading6"
                        >
                            Delivered: {deliveryDate}
                        </Typography>
                    )
                    }

                    <div className={styles.mobileLink}>
                        <Link className={styles.mobileViewLink}  to={`${route}`} state={{ fromRateProductStore: product }}>

                            {product ? (
                                <Typography
                                    variant="heading5"
                                >
                                    Rate this store
                                </Typography>
                            ) : (
                                <Typography
                                    variant="heading5"
                                >
                                    Rate this product
                                </Typography>
                            )
                            }

                        </Link>
                    </div>

                </div>

            </div>

            <div>
                <Link className={styles.link} to={`${route}`} state={{ fromRateProductStore: product }}>

                    {product ? (
                        <Typography
                            variant="heading5"
                        >
                            Rate this store
                        </Typography>
                    ) : (
                        <Typography
                            variant="heading5"
                        >
                            Rate this product
                        </Typography>
                    )
                    }

                </Link>
            </div>

        </div>
    )
}